import React from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Layout } from './components/Layout';
import { Loading } from './components/Common';
import { AuthProvider, useAuth } from './auth/AuthProvider';
import { AuthCallback } from './auth/AuthCallback';
import { AuthErrorPage } from './auth/AuthControls';
import Workspace from './pages/Workspace';
import Tickets from './pages/Tickets';
import KnowledgeBase from './pages/KnowledgeBase';
import PublicWorkspace from './pages/PublicWorkspace';
import PublicTickets from './pages/PublicTickets';
import PublicKnowledge from './pages/PublicKnowledge';
import './App.css';
import './auth/auth.css';

function AppRouter() {
  const location = useLocation();
  const {user, checking} = useAuth();
  // Resolve the one-time OAuth fragment before ANY route or existing-session check.
  if (new URLSearchParams(location.hash.slice(1)).has('session_id')) return <AuthCallback/>;
  if (checking) return <Layout><Loading/></Layout>;
  const member = user?.can_access === true;
  return <Layout><Routes>
    <Route path="/" element={member ? <Workspace/> : <PublicWorkspace/>}/>
    <Route path="/ticket/:id" element={member ? <Workspace/> : <PublicWorkspace/>}/>
    <Route path="/tickets" element={member ? <Tickets/> : <PublicTickets/>}/>
    <Route path="/kb" element={member ? <KnowledgeBase/> : <PublicKnowledge/>}/>
    <Route path="/auth/error" element={<AuthErrorPage/>}/>
    <Route path="*" element={<Navigate to="/" replace/>}/>
  </Routes></Layout>;
}

export default function App() {
  return <BrowserRouter><AuthProvider><AppRouter/><Toaster position="bottom-right" richColors closeButton/></AuthProvider></BrowserRouter>;
}